import { z } from 'zod';
/**
 * `Municipality` — la commune, **clé naturelle** : le code INSEE est la clé primaire, pas un uuid
 * (M8). C'est la seule table du modèle dans ce cas, et ce schéma reflète cette exception plutôt
 * que de la masquer derrière un identifiant technique.
 *
 * Référentiel administré par l'État : il se **lit**, il ne se saisit pas. Aucun schéma de création
 * ici, et c'est délibéré — laisser un formulaire inventer une commune ferait du code INSEE une
 * valeur libre, alors que toute la chaîne d'adresse s'appuie sur lui pour rendre la ville et le
 * code postal d'une ligne de tournée.
 *
 * `delegatedName` est nullable : il ne porte que les communes déléguées des fusions (« Andrezé »
 * dans Beaupréau-en-Mauges), et la plupart des communes n'en ont aucune.
 *
 * ⚠️ **`sector_id` est en base et n'est pas ici** (M31), et ce n'est pas un oubli : ce schéma est
 * ce que la route `/municipalities` sert au **sélecteur d'adresse**, qui n'a que le nom et le
 * code postal à montrer. Le filtre « Marché » joint `Address.insee_code → Municipality.sector_id`
 * côté serveur. Les deux lectures qui ont besoin du marché d'une commune — la couverture d'une
 * équipe et son sélecteur — ont leur schéma, `municipalityWithSectorSchema`, juste en dessous.
 */
export const municipalitySchema = z.object({
    inseeCode: z.string().min(1),
    name: z.string().min(1),
    delegatedName: z.string().nullable(),
    postalCode: z.string().min(1),
});
/**
 * Plafond du corps d'écriture. Le référentiel porte plus de 400 communes (M31) : au-delà, ce n'est plus une
 * saisie, c'est un corps à refuser avant d'interroger la base.
 */
export const MAX_COVERED_MUNICIPALITIES = 500;
/**
 * Une liste de codes INSEE telle qu'un écran l'envoie — la couverture d'une équipe, à sa création
 * comme à sa modification, et les communes d'un marché (#385). Ici, et non dans l'un des deux, pour
 * que ni l'un ni l'autre n'importe son voisin.
 *
 * ⚠️ **Un code en double se replie, il ne se refuse pas** (M21) : c'est le même choix fait deux
 * fois, pas une demande contradictoire.
 */
export const coveredInseeCodesSchema = z
    .array(z.string().trim().min(1))
    .max(MAX_COVERED_MUNICIPALITIES)
    .transform((codes) => [...new Set(codes)]);
//# sourceMappingURL=municipality.js.map